import * as Yup from 'yup';
import { States } from '../../../../../constants';
import { emailRegEx, phoneRegEx, zipCodeRegEx } from 'utils/RegularExpressions';

export const validStateOptions: string[] = States.map((state) => state.name);

const defaultStepsSchema = Yup.object({
  applicantInformation: Yup.object({
    fullName: Yup.string()
      .required('Required')
      .max(250, 'Must be less than 250 characters.'),
    contactEmail: Yup.string()
      .required('Required')
      .matches(emailRegEx, 'Please enter a valid email address'),
  }),
});

const step1Schema = Yup.object({
  application: Yup.object({
    name: Yup.string()
      .required('Required')
      .min(4, 'It must be greater than 4 character'),
    streetAddress: Yup.string()
      .required('Required')
      .min(4, 'It must be greater than 4 character'),
    city: Yup.string()
      .required('Required')
      .min(2, 'It must be greater than 2 character'),
    state: Yup.string()
      .required('Required')
      .oneOf(validStateOptions, 'Invalid option'),
    zipCode: Yup.string()
      .required('Required')
      .matches(zipCodeRegEx, 'It must be 5 digits')
      .max(5, 'It must be 5 digits')
      .min(5, 'It must be 5 digits'),
    homePhone: Yup.string().matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    workPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    otherPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    dob: Yup.string().required('Required'),
    lastFourSocial: Yup.string()
      .required('Required')
      .matches(/^\d{4}([-]|\s*)?(\d{4})?$/gm, 'It must be 4 digits')
      .max(4, 'It must be 4 digits')
      .min(4, 'It must be 4 digits'),
    gender: Yup.string().required('Required'),
    maritalStatus: Yup.string().required('Required'),
    disabled: Yup.string().required('Required'),
    cityEmployee: Yup.string().required('Required'),
    race: Yup.array().min(1, 'Required'),
  }),
});

const step2Schema = Yup.object({
  householdIncome: Yup.array(),
});

const step3Schema = Yup.object({
  propertyInformation: Yup.object({
    streetAddress: Yup.string()
      .required('Required')
      .min(4, 'It must be greater than 4 character'),
    city: Yup.string()
      .required('Required')
      .min(2, 'It must be greater than 2 character'),
    state: Yup.string()
      .required('Required')
      .oneOf(validStateOptions, 'Invalid option'),
    zipCode: Yup.string()
      .required('Required')
      .matches(zipCodeRegEx, 'It must be 5 digits')
      .max(5, 'It must be 5 digits')
      .min(5, 'It must be 5 digits'),
    housePrice: Yup.number()
      .required('Required')
      .typeError('Amount is required')
      .positive('It must be greater than 0')
      .integer('It must be integer')
      .transform((_, val) => (val ? Number(val) : undefined)),

    buyersAgentName: Yup.string()
      .required('Required')
      .min(4, 'It must be greater than 4 character'),
    buyersWorkPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    buyersAgentEmail: Yup.string().required('Required'),
    sellersName: Yup.string()
      .required('Required')
      .min(4, 'It must be greater than 4 character'),
    sellersAgentName: Yup.string()
      .required('Required')
      .min(4, 'It must be greater than 4 character'),
    sellersWorkPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    sellersAgentEmail: Yup.string().required('Required'),
  }),
});

export const BDPAValidationSchema = [
  defaultStepsSchema,
  step1Schema,
  step2Schema,
  step3Schema,
  // step4Schema,
];
